



































import Vue from 'vue';

import SldsIcon from '../Icon/Icon.vue';
import SldsButton from '../Button/Button.vue';

export default Vue.extend({
  components: {
    SldsIcon,
    SldsButton,
  },
  props: {
    theme: { type: String, default: 'error' },
    inline: { type: Boolean, default: false },
    dismissible: { type: Boolean, default: false },
    timeout: { type: Number, default: undefined },
    show: { type: Boolean, default: true },
    text: { type: String, default: undefined },
  },
  data() {
    return {
      isShow: this.inline,
      isSticky: this.timeout === 0,
      timer: undefined as number | undefined,
    };
  },
  computed: {
    iconName() {
      switch (this.theme) {
        case 'info':
          return 'info';
        case 'error':
          return 'error';
        case 'warning':
          return 'info_alt';
        case 'success':
          return 'success';
        default:
          return 'info';
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    },
  },
  mounted() {
    if (this.show) {
      this.open();
    }
  },
  methods: {
    open() {
      if (this.timeout) {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(this.close, this.timeout);
      }
      this.isShow = true;
      this.$emit('open');
    },
    close() {
      if (this.timeout) {
        window.clearTimeout(this.timer);
      }
      this.isShow = false;
      this.$emit('close');
    },
  },
});
